module.exports = "/_next/static/images/93323be818b7b142062f504d30c81336-double-card@sm-2x.png";